<template>
  <div class="wrapper">
    <div class="block-center mt-4 wd-xxl">
      <div class="card card-flat">
        <div class="card-header text-center bg-dark-green">
          <router-link :to="{name: 'tenders'}">
            <h4 class="text-white m-0">{{ $t('global.client-name') }}</h4>
          </router-link>
        </div>
        <div class="card-body">
          <form @submit.prevent="reset" class="form-modal form-recover">
            <p class="text-center py-2">{{ $t('reset.text') }}</p>
            <div v-if="errors.non_field_errors">
              <div class="alert alert-danger bg-danger-light text-center" role="alert">
                <i class="fa fa-exclamation-triangle"></i> {{ errors.non_field_errors[0] }}
              </div>
            </div>
            <div v-if="errors.key">
              <div class="alert alert-danger bg-danger-light text-center" role="alert">
                <i class="fa fa-exclamation-triangle"></i> {{ $t('reset.key-null') }}
              </div>
            </div>
            <div class="form-group">
              <label class="text-muted">{{ $t('reset.new') }}</label>
              <div class="input-group with-focus">
                <input
                  v-model="password1"
                  id="password1"
                  autocomplete="off"
                  class="form-control border-right-0"
                  :placeholder="$t('reset.new')"
                  type="password"
                  required>
                <div class="input-group-append">
                  <span class="input-group-text text-muted bg-transparent border-left-0">
                    <em class="fa fa-lock"></em>
                  </span>
                </div>
              </div>
              <ul class="parsley-errors-list filled" v-if="errors.password1">
                <li class="parsley-required">{{ errors.password1[0] }}</li>
              </ul>
            </div>
            <div class="form-group">
              <label class="text-muted">{{ $t('reset.new-again') }}</label>
              <div class="input-group with-focus">
                <input
                  v-model="password2"
                  id="password2"
                  autocomplete="off"
                  class="form-control border-right-0"
                  :placeholder="$t('reset.new-again')"
                  type="password"
                  required>
                <div class="input-group-append">
                  <span class="input-group-text text-muted bg-transparent border-left-0">
                    <em class="fa fa-lock"></em>
                  </span>
                </div>
              </div>
              <ul class="parsley-errors-list filled" v-if="errors.password2">
                <li class="parsley-required">{{ errors.password2[0] }}</li>
              </ul>
            </div>
            <button
              class="btn btn-success btn-block"
              type="submit"
              :disabled="disabled">{{ $t('reset.change') }}</button>
          </form>
        </div>
      </div>
    </div>
    <div class="p-3 text-center">
      <span>&copy; {{ $t('page.footer') }}</span>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import message from '@/message'
import {parseApiError} from '@/utils'

const getData = (route, next) => {
  const key = route.query.key
  next({
    password1: '',
    password2: '',
    key: key
  })
}

export default {
  data () {
    return {
      password1: null,
      password2: null,
      key: null,
      errors: {},
      disabled: false
    }
  },
  methods: {
    reset () {
      this.disabled = true
      this.errors = {}
      api.post('/reset_password/', {
        password1: this.password1,
        password2: this.password2,
        key: this.key
      })
        .then(() => {
          message.success('Teie salasõna uuendatud edukalt.')
          this.$store.commit('log_out')
          this.$router.push({path: '/'})
        })
        .catch(error => {
          this.disabled = false
          let errors = parseApiError(error, this.$i18n)
          if (error.response && error.response.status === 400) {
            this.errors = errors
          }
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Reset.vue